import ClassroomManagementsView from "@features/tools/view/classroom-management";

const ClassroomManagement = () => {
  return <ClassroomManagementsView />;
};

export default ClassroomManagement;
